<template>
    <div class="internship-report-progress">
        <div class="apprentice-simple-card" v-if="roadmapIn">
            <design-2021-roadmap-status-component
                class="internship-report-progress-roadmap"
                :steps-in="roadmapIn.steps"
                    :title="
                        groupIn.roadmap_name && groupIn.roadmap_name.length > 0
                            ? groupIn.roadmap_name
                            : $t('internship.road_map')
                    "
                :project-id-in="projectId">
            </design-2021-roadmap-status-component>
        </div>

        <b-row>
            <b-col
                class="left-side"
                cols="12"
                md="6">
                <div class="deadlines-progress apprentice-simple-card">
                    <div class="component-title">
                        <h5 class="title">Deadlines</h5>
                    </div>

                    <div
                        class="not-found with-header empty-assignments-list"
                        v-if="deadlinesByDate.length === 0">
                        <div class="icon">
                            <i class="fas fa-exclamation-circle"></i>
                        </div>
                        <div class="alert-notice">{{ $t('internship.no_assignments_ready_yet') }}</div>
                    </div>

                    <div
                        class="deadline"
                        v-for="(dates, datesIndex) in deadlinesByDate"
                        v-else
                        :key="datesIndex">
                        <div class="deadline-header-due-date">
                            <i class="btn-clock"></i>{{ calculateDueDate(dates.due_date) }}
                        </div>
                        <div
                            class="portfolio-deadline-item"
                            v-for="(assignment, assignmentKey) in dates.items"
                            :key="assignmentKey"
                            @click="showAssignment(assignment, projectId)">
                            <div class="content">
                                <div class="assignment-category">{{ assignment.name }}</div>
                            </div>

                            <div
                                class="progressbar"
                                v-if="assignment.type === 'assignment'">
                                <b-progress
                                    :max="assignment.progress_status.total"
                                    show-value>
                                    <b-progress-bar
                                        v-b-tooltip.hover
                                        :value="assignment.progress_status.closed"
                                        variant="closed"
                                        :title="`${assignment.progress_status.closed} $t('internship.completed')`"></b-progress-bar>
                                    <b-progress-bar
                                        v-b-tooltip.hover
                                        :value="assignment.progress_status.submitted"
                                        variant="submitted"
                                        :title="`${assignment.progress_status.submitted} $t('internship.submitted')`"></b-progress-bar>
                                    <b-progress-bar
                                        v-b-tooltip.hover
                                        :value="assignment.progress_status.reopened"
                                        variant="reopened"
                                        :title="`${assignment.progress_status.reopened} $t('internship.rejected_again')`"></b-progress-bar>
                                    <b-progress-bar
                                        v-b-tooltip.hover
                                        :value="assignment.progress_status.open"
                                        variant="open"
                                        :title="`${assignment.progress_status.open} Open`"></b-progress-bar>
                                </b-progress>
                                <span class="completed">
                                    {{ completion(assignment.progress_status) }}% {{ $t('internship.completed') }}
                                </span>
                            </div>

                            <div
                                class="progressbar"
                                v-else>
                                <b-progress
                                    :max="1"
                                    show-value>
                                    <b-progress-bar
                                        v-if="assignment.progress_status === 'closed'"
                                        v-b-tooltip.hover
                                        :value="1"
                                        variant="closed"
                                        :title="$t('internship.closed')"></b-progress-bar>
                                    <b-progress-bar
                                        v-if="assignment.progress_status === 'submitted'"
                                        v-b-tooltip.hover
                                        :value="1"
                                        variant="submitted"
                                        :title="$t('internship.submitted')"></b-progress-bar>
                                    <b-progress-bar
                                        v-if="assignment.progress_status === 'reopened'"
                                        v-b-tooltip.hover
                                        :value="1"
                                        variant="reopened"
                                        :title="$t('internship.rejected_again')"></b-progress-bar>
                                    <b-progress-bar
                                        v-if="assignment.progress_status === 'open'"
                                        v-b-tooltip.hover
                                        :value="1"
                                        variant="open"
                                        title="Open"></b-progress-bar>
                                </b-progress>
                                <span class="completed">
                                    <div
                                        v-if="
                                            assignment.progress_status === 'open' ||
                                            assignment.progress_status === 'reopened'
                                        ">
                                        {{ $t('internship.zero_per_cent_completed') }}
                                    </div>
                                    <div v-else>
                                        {{ $t('internship.hundred_per_cent_completed') }}
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </b-col>

            <b-col
                class="right-side"
                cols="12"
                md="6">
                <design-2021-portfolio-show-assignments-card-component
                    :header-name-in="$t('internship.assignment_in_progress', this.progressItems.length)"
                    :items="progressItems"
                    :project-id="projectId"
                    :in-progress="true">
                </design-2021-portfolio-show-assignments-card-component>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'design-2021-internship-report-show-progress-component',
    props: ['projectId', 'roadmapIn', 'groupIn', 'portfolioIn'],
    data() {
        return {
            portfolio: this.portfolioIn,
            value: 54,
            max: 100,
        };
    },
    computed: {
        deadlinesByDate() {
            let deadlines = [];

            if (this.portfolio.categories.length > 0) {
                for (let category of this.portfolio.categories) {
                    if (category.assignments.length > 0) {
                        for (let assignment of category.assignments) {
                            if (assignment.deadlines.length > 0) {
                                for (let deadline of assignment.deadlines) {
                                    const date = deadline.agenda_item.fulldate;
                                    const indexPos = deadlines.map((deadline) => deadline.due_date).indexOf(date);

                                    if (deadlines.length && indexPos !== -1) {
                                        deadlines[indexPos].items.push({
                                            type: 'assignment',
                                            name: assignment.name,
                                            id: assignment.id,
                                            progress_status: assignment.progress_status,
                                            deadline: deadline.agenda_item.fulldate,
                                        });
                                    } else {
                                        deadlines.push({
                                            due_date: deadline.agenda_item.fulldate,
                                            items: [
                                                {
                                                    type: 'assignment',
                                                    name: assignment.name,
                                                    id: assignment.id,
                                                    progress_status: assignment.progress_status,
                                                    deadline: deadline.agenda_item.fulldate,
                                                },
                                            ],
                                        });
                                    }
                                }
                            }

                            if (assignment.sub_assignments.length > 0) {
                                for (let sub_assignment of assignment.sub_assignments) {
                                    if (sub_assignment.deadlines.length > 0) {
                                        for (let deadline of sub_assignment.deadlines) {
                                            let status = '';

                                            if (sub_assignment.statuses.length === 0) {
                                                status = 'open';
                                            } else if (sub_assignment.statuses[0]['status'] === 1) {
                                                status = 'closed';
                                            } else if (
                                                sub_assignment.statuses[0]['status'] === 2 &&
                                                sub_assignment.statuses[0]['finished'] === 0
                                            ) {
                                                status = 'reopened';
                                            } else if (sub_assignment.statuses[0]['finished'] === 1) {
                                                status = 'submitted';
                                            } else {
                                                status = 'open';
                                            }

                                            const date = deadline.agenda_item.fulldate;
                                            const indexPos = deadlines
                                                .map((deadline) => deadline.due_date)
                                                .indexOf(date);

                                            if (deadlines.length && indexPos !== -1) {
                                                deadlines[indexPos].items.push({
                                                    type: 'sub_assignment',
                                                    name: sub_assignment.name,
                                                    id: sub_assignment.id,
                                                    progress_status: status,
                                                    deadline: deadline.agenda_item.fulldate,
                                                    assignment_id: sub_assignment.assignment_id,
                                                });
                                            } else {
                                                deadlines.push({
                                                    due_date: deadline.agenda_item.fulldate,
                                                    items: [
                                                        {
                                                            type: 'sub_assignment',
                                                            name: sub_assignment.name,
                                                            id: sub_assignment.id,
                                                            progress_status: status,
                                                            deadline: deadline.agenda_item.fulldate,
                                                            assignment_id: sub_assignment.assignment_id,
                                                        },
                                                    ],
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return deadlines;
        },
        progressItems() {
            let inProgress = [];
            for (const category of this.portfolio.categories) {
                for (const assignment of category.assignments) {
                    if (assignment.statuses.length) {
                        if (assignment.statuses[0].finished === 1 || assignment.statuses[0].status === 1) {
                            continue;
                        }
                    }

                    if (assignment.in_progress) {
                        inProgress.push({
                            category: category.name,
                            name: assignment.name,
                            id: assignment.id,
                            progress_status: assignment.progress_status,
                            deadline: assignment.deadlines.length ? assignment.deadlines[0].agenda_item : null,
                        });
                    }
                }
            }
            return inProgress;
        },
    },
    methods: {
        calculateDueDate(date) {
            const today = this.moment().startOf('day');
            const dueDate = this.moment(date);
            const days = dueDate.diff(today, 'days');
            const string_date = this.$options.filters.date_named_month(date);

            if (days >= 0) {
                return this.$tc('internship.deadline_in', days, { date: string_date, days: days });
            } else {
                return this.$t('internship.deadline_passed', { date: string_date });
            }
        },
        completion(progress) {
            if (
                parseInt(progress.closed) !== 0 ||
                (parseInt(progress.submitted) !== 0 && parseInt(progress.total) !== 0)
            ) {
                return (((progress.closed + progress.submitted) / progress.total) * 100).toFixed(0);
            }

            return 0;
        },
        showAssignment(assignment, projectId) {
            if (assignment.type === 'assignment') {
                window.location.href = this.routes.assignmentShow(assignment.id, projectId);
            } else {
                window.location.href = this.routes.assignmentShow(assignment.assignment_id, projectId);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.portfolio-progress-roadmap {
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.left-side {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.deadlines-progress {
    .deadline:not(:last-child) {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .not-found {
        margin-bottom: 45px;
    }

    .deadline-header-due-date {
        display: flex;
        align-items: center;
        font-size: 1.125rem;
        font-weight: $font-weight-bold;
        color: $danger;

        .icon {
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
        }
    }

    .portfolio-deadline-item {
        padding-top: map-get($grid-gutter-spacing, 'fifteen');
        padding-bottom: map-get($grid-gutter-spacing, 'fifteen');

        .assignment-date {
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            font-weight: $font-weight-normal;
            line-height: 1;
            font-size: $base-font-size;
            margin-bottom: map-get($grid-gutter-spacing, 'eight');

            .timestamp {
                font-weight: $font-weight-bold;
                align-self: flex-end;
            }
        }

        .assignment-title {
            font-size: $default-font-size;
        }

        .progressbar ::v-deep {
            display: flex;
            align-items: baseline;
            justify-content: flex-end;
            flex-wrap: wrap;

            .progress {
                height: 12px;
                background-color: darken($border-color, 56%);
                width: 100%;
                margin-bottom: 5px;
                border-radius: 4px;
            }

            .progress,
            .progress .progress-bar {
                border-radius: 0;
            }

            .completed {
                color: $text-color;
                font-size: 0.875rem;
            }
        }

        &:not(:last-child) {
            border-bottom: 3px dotted $border-color;
            padding-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }

        &:hover {
            cursor: pointer;
            background-color: $secondary-background-color;
            border-radius: $border-radius-content;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .portfolio-deadline-item {
        padding-left: map-get($grid-gutter-spacing, 'twenty-one');
        padding-right: map-get($grid-gutter-spacing, 'twenty-one');

        .assignment-date {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            .timestamp {
                font-weight: $font-weight-bold;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .deadlines-progress {
        height: inherit;
    }

    .left-side {
        margin-bottom: 0;
    }

    .deadlines-progress {
        .portfolio-deadline-item {
            .progressbar ::v-deep {
                justify-content: space-between;
                flex-wrap: nowrap;

                .progress {
                    width: 75%;
                    margin-bottom: 0;
                }
            }
        }
    }
}
</style>
